module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-plan"
  }, [_c('el-dialog', {
    attrs: {
      "title": "新建回款计划",
      "visible": _vm.dialogVisible,
      "modal": _vm.modal,
      "width": "700px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('el-form', {
    staticClass: "addnew-from"
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "item-select",
    class: {
      disable: _vm.customerId && _vm.customerId.nonEditable === 1
    }
  }, [(!_vm.customerId.id) ? _c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": function (queryString, cb) { return _vm.querySearchAsync(queryString, cb, 'customer'); },
      "placeholder": "请输入名称搜索或点击“选择”添加"
    },
    on: {
      "select": function (item) { return _vm.selectedChecked(item, 'customer'); }
    },
    model: {
      value: (_vm.itemValueCustomer),
      callback: function($$v) {
        _vm.itemValueCustomer = $$v
      },
      expression: "itemValueCustomer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.customerId.id) ? _c('span', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.customerId.value))]), _vm._v(" "), _c('i', {
    staticClass: "del el-icon-close",
    on: {
      "click": function($event) {
        _vm.del(1)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleSelect('customerApi')
      }
    }
  }, [_vm._v("选择")])], 1)]), _vm._v(" "), (_vm.customerId && _vm.customerId.id) ? _c('el-form-item', {
    attrs: {
      "label": "合同名称",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "item-select",
    class: {
      disable: _vm.contractId && _vm.contractId.nonEditable === 1
    }
  }, [(_vm.contractId && !_vm.contractId.id) ? _c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": function (queryString, cb) { return _vm.querySearchAsync(queryString, cb, 'contract'); },
      "placeholder": "请输入名称搜索或点击“选择”添加"
    },
    on: {
      "select": function (item) { return _vm.selectedChecked(item, 'contract'); }
    },
    model: {
      value: (_vm.itemValueContract),
      callback: function($$v) {
        _vm.itemValueContract = $$v
      },
      expression: "itemValueContract"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contractId && _vm.contractId.id) ? _c('span', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.contractId.value))]), _vm._v(" "), _c('i', {
    staticClass: "del el-icon-close",
    on: {
      "click": function($event) {
        _vm.del(2)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "select-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.handleSelect('contractApi')
      }
    }
  }, [_vm._v("选择")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.customerId && _vm.customerId.id && _vm.contractId && _vm.contractId.id) ? _c('el-form-item', {
    attrs: {
      "label": "回款计划",
      "label-width": "120px"
    }
  }, [(_vm.isToggleContract) ? _c('payment-box', {
    ref: "paymentBox",
    attrs: {
      "moduleName": 'payment',
      "contractId": _vm.contractId.id || 0
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), (!_vm.modal && _vm.dialogVisible) ? _c('div', {
    staticClass: "v-modal",
    staticStyle: {
      "z-index": "100"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a3f3974","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/payment/add-payment.vue
// module id = 1241
// module chunks = 82